//Sidebar Imports
import {
  UilEstate,
  UilClipboardAlt,
  UilUsersAlt,
  UilPackage,
  UilChartLine,
  UilCalendarAlt,
} from "@iconscout/react-unicons";

//Sidebar Data
export const SidebarData = [
  {
    icon: UilEstate,
    heading: "Dashboard",
    path:"/"
  },
  {
    icon: UilClipboardAlt,
    heading: "Facturas",
    path:"Factura"
  },
  {
    icon: UilUsersAlt,
    heading: "Clientes",
    path:"Clientes"
  },
  {
    icon: UilPackage,
    heading: "Productos",
    path:"Product"
  },
  {
    icon: UilChartLine,
    heading: "Gráfico ventas",
    path:"Analytics"
  },
  {
    icon: UilCalendarAlt,
    heading: "Calendario",
    path:  "Calendario",
  }
];

